import _ from "lodash";
import { Module } from "vuex";
import { CurrentTemplatesState } from "./types";
import { RootState } from "../../types";

import { getters, getterNames } from "./getters";
import { actions, actionNames } from "./actions";
import { mutations, mutationNames } from "./mutations";

const state = new CurrentTemplatesState();

const namespaced: boolean = true;
const modul: Module<CurrentTemplatesState, RootState> = {
  namespaced,
  getters,
  actions,
  mutations,
  state,
};

export const api = {
  namespace: "templates",
  mutations: mutationNames,
  getters: getterNames,
  actions: actionNames,
};
export default modul;
